import {cookies, isAuthRoute} from "@/util";

export default async function (to, from, next, store) {
    const isAuthenticated = store.getters['auth/loggedIn'];

    if (!isAuthenticated) {
        if (!isAuthRoute(to)) {
            next('/login');
        } else {
            next();
        }

        return false;
    }

    window.http.defaults.headers.common['Authorization'] = `Bearer ${cookies.get('chat_api_token')}`;

    if (!store.getters['auth/user']) {
        await store.dispatch('fetchCurrentUser');
    }

    if (isAuthRoute(to)) {
        next('/');
        return false;
    }

    return true;
};
